import MoreVert from '@mui/icons-material/MoreVert';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function MoreVertIcon(props: FixMe) {
  return <MoreVert {...props} />;
}

export default MoreVertIcon;
